import { Chip } from "@mui/material";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DatevProtokolleButton from "../rechnungen/DatevProtokolleButton";
import PaidIcon from "@mui/icons-material/Paid";
import { Block } from "@mui/icons-material";
import React from "react";
import { EingangsrechnungInfo } from "../../api";
import { useT } from "../../i18n";

function RechnungStatusChip({
  eingangsrechnung,
}: {
  eingangsrechnung: EingangsrechnungInfo;
}) {
  const id = eingangsrechnung.id;
  const { t } = useT("eingangsrechnung");

  let bezahltAmString = "";
  if (eingangsrechnung.bezahltAm) {
    try {
      const date = new Date(eingangsrechnung.bezahltAm);
      bezahltAmString = date.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch (error) {
      bezahltAmString = t("no-date");
    }

    return (
        <Chip
            icon={<PaidIcon />}
            title={"Bezahlt"}
            color={"success"}
            label={bezahltAmString}
        ></Chip>
    );
  }

  switch (eingangsrechnung.belegStatus) {
    case "IN_ERKENNUNG":
      return (
        <Chip
          icon={<TextIncreaseIcon />}
          title={"In Erkennung"}
          label={"in Erkennung"}
        ></Chip>
      );
    case "OFFEN":
      return (
        <Chip
          icon={<SpellcheckIcon />}
          title={"Offen"}
          color={"secondary"}
          label={"offen"}
        ></Chip>
      );
    case "IN_PRUEFUNG":
      return (
        <Chip
          icon={<PlaylistAddCheckCircleIcon />}
          title={"In Prüfung"}
          color={"warning"}
          label={"in Prüfung"}
        ></Chip>
      );
    case "FREIGEGEBEN":
      return (
        <Chip
          icon={<TaskAltIcon />}
          title={"Freigegeben"}
          color={"success"}
          label={"freigegeben"}
        ></Chip>
      );
    case "ABGELEHNT":
      return (
        <Chip
          icon={<HighlightOffIcon />}
          title={"Abgelehnt"}
          color={"error"}
          label={"abgelehnt"}
        ></Chip>
      );
    case "IN_DATEV":
      return (
        <DatevProtokolleButton
          id={id}
          label={"in DATEV"}
          color={"success"}
          title={"Verarbeitet durch DATEV"}
        />
      );
    case "VERARBEITUNG_DATEV":
      return (
        <DatevProtokolleButton
          id={id}
          label={"Verarbeitung DATEV"}
          color={"warning"}
          title={"Verarbeitung durch DATEV"}
        />
      );
    case "FEHLER_BEI_UEBERTRAG_DATEV":
      return (
        <DatevProtokolleButton
          id={id}
          label={"Fehler DATEV"}
          color={"error"}
          title={"Fehler bei Übertrag nach Datev"}
        />
      );
    case "FEHLER_GOOGLE":
      return (
        <DatevProtokolleButton
          id={id}
          label={"Fehler Erkennung"}
          color={"warning"}
          title={"Fehler Erkennung Google"}
        />
      );
    case "BEZAHLT":
      return (
        <Chip
          icon={<PaidIcon />}
          title={"Bezahlt"}
          color={"success"}
          label={bezahltAmString}
        ></Chip>
      );
    case "STORNIERT":
      return (
        <Chip
          icon={<Block />}
          title={"Storniert"}
          color={"secondary"}
          label={"storniert"}
        ></Chip>
      );
    default:
      console.warn(
        `RechnungStatusChip: unhandled belegStatus “${eingangsrechnung.belegStatus}”`
      );
      return <Chip title={t("unknown-status")} label={t("unknown-status")} />;
  }
}

export default RechnungStatusChip;
